import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import { Switch } from "@sellar-io/components";

export const ReactHookFormSwitch = <T extends FieldValues>({
  control,
  name,
  disabled,
}: {
  control: Control<T>;
  name: FieldPath<T>;
  disabled?: boolean;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <Switch onChange={onChange} checked={value} disabled={disabled} />
      )}
    />
  );
};
